import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=1b4664cf&"
import script from "./customer-info.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-info.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports